import styled from 'styled-components'

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MainContent = styled.div`
  margin-top: 96px;
  width: 360px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km8};
    width: 100%;
    padding: ${({ theme }) => theme.spacing.km3};
  }
`
